export var EmploymentBasisType;
(function (EmploymentBasisType) {
    EmploymentBasisType["FullTime"] = "FULL_TIME";
    EmploymentBasisType["PartTime"] = "PART_TIME";
    EmploymentBasisType["Casual"] = "CASUAL";
    EmploymentBasisType["Contractor"] = "CONTRACTOR";
    EmploymentBasisType["MaternityLeave"] = "MATERNITY_LEAVE";
})(EmploymentBasisType || (EmploymentBasisType = {}));
//# sourceMappingURL=EmploymentBasisType.js.map